/**
 * vendor-bundle.ts
 *
 * Замена bundleLibs плагина esbuild.
 * Импортирует legacy-библиотеки, которые ранее склеивались в libs.js.
 *
 * ВАЖНО: Vite (Rolldown) обрабатывает все импорты через ESM-контекст,
 * где `this === undefined`. UMD-обёртки не могут зарегистрировать глобальные
 * переменные автоматически. Поэтому импортируем ESM-версии и явно
 * присваиваем на window для legacy-кода.
 */

// SignalR — явно экспортируем на window для legacy .cshtml
import * as signalR from '@microsoft/signalr';
window.signalR = signalR;

// Local libraries
import './local-libs/custom-rating-input.js';
